import { Injectable } from '@angular/core';
import { CommonapiService } from 'src/app/Module/Shared/Service/Commonapi.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerMeetingService {

  constructor(public api: CommonapiService) { }

  async GetCustomerMeeting(obj: any, isformupload: boolean) {
    return this.api.apiPost(false, `SalesLogin/GetCustomerMeeting`, obj, isformupload);
  }

  async SaveCustomerMeeting(obj: any, isformupload: boolean) {
    return this.api.apiPostServerError(false, `SalesLogin/SaveCustomerMeeting`, obj, isformupload);
  }

  async MeetingImageUpload(obj:any,isformupload:boolean) {
    return this.api.apiPost(false, `SalesLogin/MeetingImageUpload`,obj,true);
  }


  async MeetingAddressUpload(obj:any,isformupload:boolean) {
    return this.api.apiPost(false, `SalesLogin/MeetingAddressUpload`,obj,true);
  }


  async GetProductSearchResultList(obj: any, isformupload: boolean) {
    return this.api.apiPost(false, `SalesLogin/GetProductSearchResultList`, obj, isformupload);
  }

  async GetProductSearchFrequentlyResultList(obj: any, isformupload: boolean) {
    return this.api.apiPost(false, `SalesLogin/GetProductSearchFrequentlyResultList`, obj, isformupload);
  }

  async GetDistributorLoadDetails(obj: any, isformupload: boolean) {
    return this.api.apiPost(false, `SalesLogin/GetDistributorLoadDetails`, obj, isformupload);
  }

  async GetDistributorSearchDetails(obj: any, isformupload: boolean) {
    return this.api.apiPost(false, `SalesLogin/GetDistributorSearchDetails`, obj, isformupload);
  }

  async GetInventoryPopupList(obj: any, isformupload: boolean) {
    return this.api.apiPost(false, `SalesLogin/GetInventoryPopupList`, obj, isformupload);
  }

  async UpdateInventoryPopup(obj: any, isformupload: boolean) {
    return this.api.apiPost(false, `SalesLogin/UpdateInventoryPopup`, obj, isformupload);
  }

}
